import React from 'react'
import { HiOutlineExclamationCircle } from 'react-icons/hi'

// Shell visual comun del branch `isAnswer` de los QuestionType*: unifica el
// label, la marca de obligatoria y el mensaje de error en un solo lugar.
const AnswerField = ({ label, required, error, children }) => (
    <div>
        {label && (
            <label className="block text-sm font-medium text-gray-900 dark:text-gray-100 mb-1.5">
                {label}
                {required && <span className="text-rose-500 ml-0.5">*</span>}
            </label>
        )}
        {/* El anillo marca el control entero sin tocar los 9 QuestionType*: sirve
            igual para un grupo de option-cards que para un input suelto. */}
        <div className={error ? 'rounded-lg ring-1 ring-rose-400 ring-offset-2 dark:ring-offset-gray-800' : undefined}>
            {children}
        </div>
        {error && (
            <span className="mt-1.5 flex items-center gap-1 text-xs text-rose-500">
                <HiOutlineExclamationCircle className="shrink-0 text-sm" />
                {error}
            </span>
        )}
    </div>
)

export default AnswerField
